export default __webpack_public_path__ + "static/media/me.98919b94.png";